import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'
import { commitSchema } from './commit'

export const branchLineageSchema = z.array(
  z.object({
    checkoutAt: z.string(),
    branchId: z.string(),
    lastSyncedAt: z.string(),
  })
)

export type BranchLineage = z.infer<typeof branchLineageSchema>

export const branchSchema = baseSchema.extend({
  name: z.string(),
  description: z.string().optional(),
  /** Protected. */
  headCommitId: z.string().nullable(),
  /** Protected. */
  headCommit: z.lazy(() => commitSchema.nullish()), // optional for backwards compat
  rollback: z
    .object({
      commitId: z.string(),
      isoDate: z.string(),
    })
    .nullish(),
  workingRootBlockId: z.string().nullable(),
  isDefault: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string().nullish(),
  typesenseCollections: z.string().array().optional(),
  contentRequestIds: z.string().array().optional(),
  sourceBranchId: z.string().nullish(),
  archivedAt: z.string().nullish(),
  archivedBy: z.string().nullish(),
  authorId: z.string().optional(),
  contributors: z.array(z.string()).optional(),
  lineage: branchLineageSchema.optional(),
  git: z
    .object({ branch: z.string(), deploymentUrl: z.string().nullish() })
    .nullish(),
  isInlineSuggestion: z.literal(true).optional(),
  inlineSuggestionAppliedAt: z.string().nullish(),
})

export type Branch = z.infer<typeof branchSchema>
export type BranchUpdate = Update<Branch>

export const branchBaseOps = generate('branch', branchSchema.parse)
